import type {NamedSetState} from 'app/gemStore/devtools';

import type {ScrollDeeplinkItem, ScrollDeeplinkSlice} from './types';

export const createScrollDeeplinkSlice = (set: NamedSetState<ScrollDeeplinkSlice>, get: () => ScrollDeeplinkSlice) => ({
    scrollDeeplink: [],
    addScrollDeeplinkItem(item: ScrollDeeplinkItem): void {
        if (!get().scrollDeeplink.some((prevItem) => prevItem.cId === item.cId && prevItem.type === item.type)) {
            set({scrollDeeplink: [...get().scrollDeeplink, item]}, false, 'scrollDeeplink/addScrollDeeplinkItem');
        }
    },
    removeScrollDeeplinkItem(cId: string): void {
        if (get().scrollDeeplink.some((prevItem) => prevItem.cId === cId && prevItem.type === 'LAZY_SCROLL')) {
            set(
                {
                    scrollDeeplink: get().scrollDeeplink.filter((item) => {
                        return item.cId !== cId || item.type !== 'LAZY_SCROLL';
                    }),
                },
                false,
                'scrollDeeplink/removeScrollDeeplinkItem',
            );
        }
    },
});
